import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../../common";
import { authTokenSelector } from '../../../session';
import { QUIZ_ATTEMPTS_API_ENDPOINT } from '../endpoints';
import { updateResourceState } from '../util';

const actions = createActions({
  ATTEMPTS: {
    GET: (contentId, query) => ({ contentId, query }),
    API: {
      GET: apiResourceActionCreator('attempts')
    }
  }
})

export const apiAction = (authToken, contentId, query) => commonApiActions.authenticated.get(`${QUIZ_ATTEMPTS_API_ENDPOINT}${endpointQuery({ ...(query || {}), contentId })}`, authToken, actions.attempts.api.get)

export function* getQuizAttempts(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.contentId, action.payload.query));
}

const configuration = {
  name: 'get',
  action: actions,
  sagas: getQuizAttempts,
  reducers: {
    request: (state, action) => updateResourceState(state, 'attempts', ({
      isFetching: true
    })),
    success: (state, action) => updateResourceState(state, 'attempts', ({
      isFetching: false,
      result: action.payload.attempts.attempts,
      relatedTasks: action.payload.attempts.tasks,
      error: null
    })),
    failed: (state, action) => updateResourceState(state, 'attempts', ({
      isFetching: false,
      error: action.payload.error
    }))
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/attempts/get.js